import { Flex, Typography } from 'UI';
import React, { FC } from 'react';
import { FONT_WEIGHT, TextColor, TEXT_COLOR } from 'styles/constants';

interface Props {
	title?: string;
	subtitle?: string;
	children?: React.ReactNode;
	titleSize?: number;
	titleColor?: TextColor | string;
	titleWeight?: number;
	subtitleSize?: number;
	subtitleColor?: TextColor | string;
	subtitleWeight?: number;
	image?: React.ReactNode;
	marginTop?: string;
	configPilates?: boolean;
}

export const QuestionWrapperV2: FC<Props> = props => {
	const {
		title,
		titleSize = 22,
		titleColor = TEXT_COLOR.TEXT1,
		titleWeight = FONT_WEIGHT.BOLD,
		subtitle,
		subtitleColor = TEXT_COLOR.TEXT1,
		subtitleSize = 16,
		subtitleWeight = FONT_WEIGHT.REGULAR,
		image,
		children,
		marginTop,
		configPilates,
	} = props;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: 15,
				width: '100vw',
				height: '100vh',
				marginTop,
				position: 'fixed',
				maxWidth: '465px',
				top: 0,
				left: 0,
				right: 0,
				padding: '60px 20px 0 20px',
				margin: '0 auto',
			}}
		>
			{title && (
				<Typography
					size={titleSize}
					color={titleColor}
					weight={titleWeight}
					textAlign={configPilates ? 'center' : 'left'}
				>
					{title}
				</Typography>
			)}
			{subtitle && (
				<Typography
					size={subtitleSize}
					color={subtitleColor}
					weight={subtitleWeight}
					textAlign={configPilates ? 'center' : 'left'}
				>
					{subtitle}
				</Typography>
			)}
			{image && (
				<Flex justify='center' align='center'>
					{image}
				</Flex>
			)}
			{children}
		</div>
	);
};
